"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _Settings = require("./Settings");
var _cccisdColorPicker = require("cccisd-color-picker");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(_ref) {
  var _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? _Settings.initialSettings : _ref$settings;
  return settings && settings.color && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].thumbnail,
    style: {
      backgroundColor: (0, _cccisdColorPicker.getColor)(settings.color),
      opacity: settings.isColorLightened ? 0.1 : 1
    }
  });
};